import { axiosRequest } from '@/util/axios-request';
var ruleList = '/web/leave/setting_list';
var ruleInfoList = '/web/leave/setting_info';
var ruleAdd = '/web/leave/add_setting';
var ruleEdit = '/web/leave/edit_setting';
var ruleUrl = '/web/leave/del_setting';
var restList = '/web/leave/leave_days_list';
var restEditList = '/web/leave/edit_leave_days';
var supCard = '/web/attendance/reissue_setting';
var getSupCard = '/web/attendance/reissue_info';
var otTypes = '/web/apply/overtime_types';
var otInfo = '/web/apply/ot_setting_info';
var otAdd = '/web/apply/save_ot_setting';
var getSettingCycle = '/web/leave/get_setting_cycle';
var getTravel = '/web/apply/travelList';
var saveRule = '/web/apply/store';
var getDetail = '/web/apply/detail';
var outList = '/web/apply/list';
var senior = '/web/workflow/getAdvanceSetting';
var setSenior = '/web/workflow/saveAdvanceSetting';
var applyList = '/web/apply/list';
var addApply = '/web/apply/add';
var delApply = '/web/apply/del';
var editApply = '/web/apply/edit';
var detailApply = '/web/apply/detail';

// 请假-员工余额导出
export var exportLeaveDays = function exportLeaveDays(data) {
  return axiosRequest({
    url: '/web/leave/exportLeaveDays',
    method: 'get'
  });
};
export var ruleListFn = function ruleListFn(data) {
  return axiosRequest({
    url: ruleList,
    data: data
  });
};
export var ruleInfoListFn = function ruleInfoListFn(data) {
  return axiosRequest({
    url: ruleInfoList,
    data: data
  });
};
export var ruleAddFn = function ruleAddFn(data) {
  return axiosRequest({
    url: ruleAdd,
    data: data
  });
};
export var ruleEditFn = function ruleEditFn(data) {
  return axiosRequest({
    url: ruleEdit,
    data: data
  });
};
export var ruleFn = function ruleFn(data) {
  return axiosRequest({
    url: ruleUrl,
    data: data
  });
};
export var restListFn = function restListFn(data) {
  return axiosRequest({
    url: restList,
    data: data
  });
};
export var restEditListFn = function restEditListFn(data) {
  return axiosRequest({
    url: restEditList,
    data: data
  });
};
export var supCardFn = function supCardFn(data) {
  return axiosRequest({
    url: supCard,
    data: data
  });
};
export var getSupCardFn = function getSupCardFn(data) {
  return axiosRequest({
    url: getSupCard,
    data: data
  });
};
export var otTypesFn = function otTypesFn(data) {
  return axiosRequest({
    url: otTypes,
    data: data
  });
};
export var otInfoFn = function otInfoFn(data) {
  return axiosRequest({
    url: otInfo,
    data: data
  });
};
export var otAddFn = function otAddFn(data) {
  return axiosRequest({
    url: otAdd,
    data: data
  });
};
export var getSettingCycleFn = function getSettingCycleFn() {
  return axiosRequest({
    url: getSettingCycle
  });
};
export var getTravelFn = function getTravelFn() {
  return axiosRequest({
    url: getTravel
  });
};
export var saveRuleFn = function saveRuleFn(data) {
  return axiosRequest({
    url: saveRule,
    data: data
  });
};
export var getDetailFn = function getDetailFn(data) {
  return axiosRequest({
    url: getDetail,
    data: data
  });
};
export var outListFn = function outListFn(data) {
  return axiosRequest({
    url: outList,
    data: data
  });
};
// 判断是否应该展示员工假期余额折算规则输入框
export var showConversionRateInput = function showConversionRateInput(data) {
  return axiosRequest({
    url: '/web/leave/showConversionRateInput',
    data: data
  });
};
// 获取高级设置
export var getSenior = function getSenior(data) {
  return axiosRequest({
    url: senior,
    data: data
  });
};
// 设置高级设置
export var setSeniorFn = function setSeniorFn(data) {
  return axiosRequest({
    url: setSenior,
    data: data
  });
};

// 获取加班规则列表
export var getApplyList = function getApplyList(data) {
  return axiosRequest({
    url: applyList,
    data: data
  });
};

// 新增加班规则
export var applyAdd = function applyAdd(data) {
  return axiosRequest({
    url: addApply,
    data: data
  });
};
// 删除加班规则
export var applyDel = function applyDel(data) {
  return axiosRequest({
    url: delApply,
    data: data
  });
};

// 编辑加班规则
export var applyEdit = function applyEdit(data) {
  return axiosRequest({
    url: editApply,
    data: data
  });
};

// 考勤加班详情

export var applyDeyail = function applyDeyail(data) {
  return axiosRequest({
    url: detailApply,
    data: data
  });
};